module.exports = __webpack_public_path__ + "static/media/cesped_verano_largo.1e9818f8.jpg";